<template>
  <li class="font-semibold list-none block">
    <div class="flex items-center justify-between cursor-pointer" v-on:click="toggleShow()">
      <Link class="group flex items-center py-3" as="button" type="button" href="#">
        <icon :name="this.icon" class="mr-2 w-4 h-4 fill-indigo-400 group-hover:fill-white" />
        <div class = "text-indigo-300 group-hover:text-white">{{title}}</div>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="dropdown-menu fill-indigo-400 group-hover:fill-white" :class="{'rotate-90' : showMenu}"  viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0V0z"/><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
        </svg>
      </Link>

    </div>
    <ul class="ml-4 overflow-hidden dropdown-menu font-normal" :class="this.class" >
      <slot></slot>
    </ul>
  </li>

</template>

<script>
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  name: 'DropdownMenu',
  props: ["title", "height", "icon"],
  components: {
    Icon,
    Link,
  },
  data() {
    return {
      showMenu: false
    };
  },

  methods: {
    toggleShow() {
      this.showMenu = !this.showMenu;
    }
  },

  computed: {
    class() {
      return this.showMenu ? this.height : "h-0";
    }
  }
}
</script>

<style scoped>
  .dropdown-menu {
    transition: 300ms;
  }

  svg.rotate-90 {
    transform: rotate(90deg);
  }

</style>
